import { CustomerType } from "@origin-digital/platform-enums";
import { getMcAppFromBaseProps } from "../lib/baseProps";
import {
  CommonParameters,
  IBaseProps,
  IMcAppType,
  NavFlow,
  Tab,
} from "../mcApp.types";

const {
  accountNumber,
  cardId,
  isDigishift,
  midflow,
  referrerPath,
} = CommonParameters;

const paymentMethodParameters = {
  isDigishift,
  midflow,
  referrerPath,
};

const baseProps = {
  path: "/my-account/payment-methods",
  title: "Payment methods",
  navFlow: NavFlow.MODAL,
  parent: Tab.MORE,
};

const createPaymentMcApp = ({ name, ...props }: IBaseProps): IMcAppType[] => {
  name = `paymentMethod${name}`;
  return [
    getMcAppFromBaseProps(
      {
        ...props,
        name: `${name}_SAP`,
        intent: name,
      },
      paymentMethodParameters
    ),
    getMcAppFromBaseProps(
      {
        ...props,
        name: `${name}_DIGISHIFT`,
        digishiftPath: "/manage/card-expiry",
        intent: name,
      },
      paymentMethodParameters
    ),
    getMcAppFromBaseProps(
      {
        ...props,
        name: `${name}_MAGICLINK`,
        magiclinkPath: "/task/card-expiry",
        intent: name,
      },
      paymentMethodParameters
    ),
  ];
};

const paymentApps: IBaseProps[] = [
  {
    name: "AddBankAccount",
    subPath: "add-bank-account",
    description: "Add a bank account",
    ...baseProps,
  },
  {
    name: "RemoveBankAccount",
    subPath: "remove-bank-account/:bankAccountId",
    description: "Remove a bank account",
    ...baseProps,
    parameters: {
      required: ["bankAccountId"],
      properties: {
        bankAccountId: {
          type: "string",
          description: `internal ID of bank account id`,
        },
      },
    },
  },
  {
    name: "AddCard",
    subPath: "add-card",
    description: "Add credit card details",
    ...baseProps,
    parameters: {
      required: ["cardId"],
      properties: { cardId: CommonParameters.cardId },
    },
  },
  {
    name: "EditCard",
    subPath: "edit-card/:cardId",
    description: "Edit credit card details",
    ...baseProps,
    parameters: {
      required: ["cardId"],
      properties: { cardId: CommonParameters.cardId },
    },
  },
  {
    name: "RemoveCard",
    subPath: "remove-card/:cardId",
    description: "Remove credit card",
    ...baseProps,
    parameters: {
      required: ["cardId"],
      properties: { cardId: CommonParameters.cardId },
    },
  },
  {
    name: "Dashboard",
    subPath: "",
    description: "Payment methods landing page",
    ...baseProps,
    navFlow: NavFlow.STANDARD,
  },
];

export const updateCardExpiry_KRAKEN: IMcAppType = {
  name: "paymentMethodEditCard_KRAKEN",
  path: "/my/direct-debit/update-card-expiry",
  parameters: {
    properties: { accountNumber, cardId },
    required: ["accountNumber", "cardId"],
  },
  description: "Update the card expiry for the specified card",
  navFlow: NavFlow.MODAL,
  title: "Update card expiry",
  parent: Tab.MORE,
  conditions: {
    intent: "paymentMethodEditCard",
    customerType: CustomerType.kraken,
  },
};

const paymentMethods: IMcAppType[] = paymentApps.flatMap((app) =>
  createPaymentMcApp(app)
);
paymentMethods.push(updateCardExpiry_KRAKEN);

export { paymentMethods };
